/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalDocumentToSubmit } from './PalDocumentToSubmit';
import {
    PalDocumentToSubmitFromJSON,
    PalDocumentToSubmitFromJSONTyped,
    PalDocumentToSubmitToJSON,
    PalDocumentToSubmitToJSONTyped,
} from './PalDocumentToSubmit';

/**
 * 
 * @export
 * @interface AddDocumentToPalAuthSubmission201Response
 */
export interface AddDocumentToPalAuthSubmission201Response {
    /**
     * 
     */
    data?: PalDocumentToSubmit;
}

/**
 * Check if a given object implements the AddDocumentToPalAuthSubmission201Response interface.
 */
export function instanceOfAddDocumentToPalAuthSubmission201Response(value: object): value is AddDocumentToPalAuthSubmission201Response {
    return true;
}

export function AddDocumentToPalAuthSubmission201ResponseFromJSON(json: any): AddDocumentToPalAuthSubmission201Response {
    return AddDocumentToPalAuthSubmission201ResponseFromJSONTyped(json, false);
}

export function AddDocumentToPalAuthSubmission201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddDocumentToPalAuthSubmission201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalDocumentToSubmitFromJSON(json['data']),
    };
}

export function AddDocumentToPalAuthSubmission201ResponseToJSON(json: any): AddDocumentToPalAuthSubmission201Response {
    return AddDocumentToPalAuthSubmission201ResponseToJSONTyped(json, false);
}

export function AddDocumentToPalAuthSubmission201ResponseToJSONTyped(value?: AddDocumentToPalAuthSubmission201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalDocumentToSubmitToJSON(value['data']),
    };
}

